import { createContext } from 'react';

export interface PreviewContextValue {
  // preview opened from the marketplace offer, i.e. the audience is a potential customer
  isMarketplacePreview: boolean;
  leavePreview: () => void;
  // opens the "preview ends here" modal from locked content
  showPreviewEndModal: () => void;
  showCertificatePreview: () => void;
}

// Provided by ContentViewerPage only when the course is shown in preview mode
export const PreviewContext = createContext<PreviewContextValue | undefined>(undefined);
